import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    rootDir: string = '';

    constructor(private httpClient: HttpClient) {
        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};

        if (browserWindowEnv.hasOwnProperty('rootDir')) {
            this.rootDir = window['__env']['rootDir'];
        }
    }

    public get(url: string, data: any) {
        return this.httpClient.get(this.rootDir + url + data);
    }

    public post(url: string, data: any) {
        return this.httpClient.post(this.rootDir + url, data);
    }

    public postWithOptions(url: string, data: any, options: any) {
        return this.httpClient.post(this.rootDir + url, data, options);
    }
}
